import { runLines } from "./payroll.js";
import { migrateWorkLogs } from "./work-logs.js";
import { DEFAULT_ROLES } from "./reference.js";
import { P } from "./format.js";
import { addDays, wd } from "./dates.js";
import { mkRun, postAccrual, postRelease } from "./payroll.js";
import { invTotals } from "./invoicing.js";

function seed() {
  const s = {
    v: 6,
    roles: JSON.parse(JSON.stringify(DEFAULT_ROLES)),
    lockedThrough: "2026-06-30",
    audit: [],
    seq: { je: 0, run: 0, lv: 0 },
    users: [
      {
        id: "u0",
        name: "Dana Cruz",
        role: "SUPER",
        emp: null,
        title: "IT & systems administrator",
      },
      {
        id: "u1",
        name: "Ryan Celis",
        role: "OWNER",
        emp: null,
        title: "President & Owner",
      },
      { id: "u2", name: "Liza Mercado", role: "FIN", emp: "E002" },
      { id: "u3", name: "Paolo Dizon", role: "ACCT", emp: "E003" },
      { id: "u4", name: "Grace Tolentino", role: "HR", emp: "E004" },
      { id: "u5", name: "Mark Sison", role: "PAY", emp: "E005" },
      {
        id: "u6",
        name: "Ramon Villareal",
        role: "HEAD",
        emp: "E001",
        dept: "Engineering",
      },
      { id: "u7", name: "Jun Abad", role: "EMP", emp: "E006" },
      {
        id: "u8",
        name: "R. Santos, CPA",
        role: "AUD",
        emp: null,
        title: "Santos & Co. (external audit)",
        expires: "2026-12-31",
      },
      {
        id: "u9",
        name: "Bea Navarro",
        role: "ACCT",
        emp: null,
        title: "Junior accountant (starting Nov)",
        status: "INVITED",
      },
    ],
    employees: [
      [
        "E001",
        "Ramon Villareal",
        "Engineering Director",
        "Engineering",
        120000,
        "2017-03-01",
        0,
        ["PME", "0004127", "2027-03-15"],
      ],
      [
        "E002",
        "Liza Mercado",
        "Finance Manager",
        "Finance",
        85000,
        "2019-07-15",
        0,
        ["CPA", "0109834", "2026-11-30"],
      ],
      ["E003", "Paolo Dizon", "Accountant", "Finance", 40000, "2022-01-10"],
      [
        "E004",
        "Grace Tolentino",
        "HR & Admin Manager",
        "HR & Admin",
        60000,
        "2020-05-04",
      ],
      [
        "E005",
        "Mark Sison",
        "Payroll & Admin Officer",
        "HR & Admin",
        32000,
        "2023-02-01",
      ],
      [
        "E006",
        "Jun Abad",
        "Project Engineer (Mechanical)",
        "Engineering",
        45000,
        "2021-09-06",
        0,
        ["RME", "0071562", "2028-06-30"],
      ],
      [
        "E007",
        "Carla Bautista",
        "Electrical Design Engineer",
        "Engineering",
        52000,
        "2022-11-14",
        0,
        ["REE", "0048311", "2026-10-31"],
      ],
      [
        "E008",
        "Noel Garcia",
        "CAD Technician",
        "Engineering",
        28000,
        "2020-08-03",
      ],
      [
        "E009",
        "Ana Reyes",
        "Safety Officer",
        "Engineering",
        35000,
        "2026-06-01",
        "PROBATIONARY",
        ["SO2 (DOLE)", "SO2-2025-1187", "2027-08-01"],
      ],
    ].map((r, i) => ({
      id: r[0],
      name: r[1],
      position: r[2],
      dept: r[3],
      basic: r[4],
      hired: r[5],
      status: r[6] || "REGULAR",
      lic: r[7] || null,
      tin: `4${31 + i}-${512 + i * 7}-${208 + i * 3}-000`,
      sss: `34-${5120000 + i * 1311}-${i + 1}`,
    })),
    je: [],
    runs: [],
    leaves: [],
    filed: { "1601-C|2026-09": "2026-10-09", "2307|2026-Q3": "2026-10-16" },
    projects: [
      [
        "BLR",
        "Boiler retrofit, owner's engineer",
        "Western Visayas Power (sample)",
        12000000,
        78,
        7800000,
        7200000,
        "E001",
        3200,
        2640,
      ],
      [
        "CNV",
        "Conveyor & dust collection design",
        "Visayas Cement (sample)",
        8500000,
        70,
        5950000,
        5600000,
        "E006",
        2400,
        2050,
      ],
      [
        "ELC",
        "Electrical load study & substation design",
        "Ilonggo Food Processing (sample)",
        5200000,
        80,
        4160000,
        4000000,
        "E007",
        1500,
        1180,
      ],
      [
        "HSE",
        "HSE audit & process safety gap assessment",
        "Capiz Sugar Milling (sample)",
        3600000,
        90,
        3240000,
        3000000,
        "E009",
        900,
        860,
      ],
      [
        "FPR",
        "Fire protection design review",
        "Guimaras Logistics Park (sample)",
        1800000,
        72,
        1300000,
        1200000,
        "E006",
        600,
        410,
      ],
    ].map((r) => ({
      code: r[0],
      name: r[1],
      client: r[2],
      contract: P(r[3]),
      pct: r[4],
      recog: P(r[5]),
      billed: P(r[6]),
      lead: r[7],
      hb: r[8],
      ha: r[9],
    })),
  };
  const J = (date, memo, lines, by = "u3", ap = "u2") =>
    s.je.push({
      id: "JV-" + String(++s.seq.je).padStart(4, "0"),
      date,
      memo,
      lines: lines.map(([a, d, c]) => ({ a, d: P(d), c: P(c) })),
      status: "POSTED",
      by,
      ap,
      src: "manual",
    });
  J("2026-01-01", "Opening balances FY2026", [
    ["1020", 4800000, 0],
    ["1110", 2350000, 0],
    ["1120", 620000, 0],
    ["1130", 900000, 0],
    ["1450", 180000, 0],
    ["1510", 3200000, 0],
    ["1520", 0, 1150000],
    ["2110", 0, 640000],
    ["2120", 0, 1100000],
    ["3010", 0, 5000000],
    ["3020", 0, 4160000],
  ]);
  J(
    "2026-09-30",
    "Progress billings Jan–Sep, 12% VAT; 7.5% retention held by clients",
    [
      ["1110", 21840000, 0],
      ["1120", 1680000, 0],
      ["4010", 0, 21000000],
      ["2240", 0, 2520000],
    ],
  );
  J(
    "2026-09-30",
    "Revenue earned not yet billed, percentage of completion (PFRS 15)",
    [
      ["1130", 1450000, 0],
      ["4010", 0, 1450000],
    ],
  );
  J(
    "2026-09-30",
    "Client collections; 15% CWT on professional fees (ATC WC011)",
    [
      ["1020", 17460000, 0],
      ["1420", 2700000, 0],
      ["1110", 0, 20160000],
    ],
  );
  J("2026-09-30", "Subconsultant fees Jan–Sep", [
    ["5110", 4200000, 0],
    ["1410", 504000, 0],
    ["2110", 0, 4704000],
  ]);
  J("2026-09-30", "Subconsultant payments; 10% EWT on professional fees", [
    ["2110", 4900000, 0],
    ["1020", 0, 4480000],
    ["2230", 0, 420000],
  ]);
  J("2026-09-30", "Site travel and mobilization Jan–Sep", [
    ["5120", 1380000, 0],
    ["1410", 96000, 0],
    ["1020", 0, 1476000],
  ]);
  J("2026-09-30", "Office rent Jan–Sep; 5% EWT on rent (ATC WC100)", [
    ["5220", 1260000, 0],
    ["1410", 151200, 0],
    ["1020", 0, 1348200],
    ["2230", 0, 63000],
  ]);
  J("2026-09-30", "Utilities and communications Jan–Sep", [
    ["5230", 420000, 0],
    ["1410", 50400, 0],
    ["1020", 0, 470400],
  ]);
  J("2026-09-30", "Professional liability insurance Jan–Sep", [
    ["5240", 360000, 0],
    ["1020", 0, 360000],
  ]);
  J("2026-09-30", "Engineering software subscriptions Jan–Sep", [
    ["5260", 960000, 0],
    ["1410", 115200, 0],
    ["1020", 0, 1075200],
  ]);
  J("2026-09-30", "Payroll Jan–Sep, paid and remitted", [
    ["5100", 2520000, 0],
    ["5010", 1953000, 0],
    ["5050", 400000, 0],
    ["1020", 0, 4873000],
  ]);
  J("2026-09-30", "Depreciation Jan–Sep", [
    ["5250", 480000, 0],
    ["1520", 0, 480000],
  ]);
  J("2026-07-24", "2550Q Q1–Q2 2026 paid", [
    ["2240", 1680000, 0],
    ["1410", 0, 611200],
    ["1020", 0, 1068800],
  ]);
  J("2026-07-31", "1601-EQ Q1–Q2 2026 paid", [
    ["2230", 322000, 0],
    ["1020", 0, 322000],
  ]);
  s.je.push({
    id: "JV-" + String(++s.seq.je).padStart(4, "0"),
    date: "2026-10-20",
    memo: "Accrue October subconsultant fee, structural review for BLR; 10% EWT",
    lines: [
      { a: "5110", d: P(280000), c: 0 },
      { a: "1410", d: P(33600), c: 0 },
      { a: "2110", d: 0, c: P(285600) },
      { a: "2230", d: 0, c: P(28000) },
    ],
    status: "DRAFT",
    by: "u3",
    src: "manual",
  });
  [
    ["Lapuz, Iloilo City", "VI"],
    ["Naga City, Cebu", "VII-A"],
    ["Pavia, Iloilo", "VI"],
    ["Pontevedra, Capiz", "VI"],
    ["Buenavista, Guimaras", "VI"],
  ].forEach(([site, region], i) =>
    Object.assign(s.projects[i], { site, region }),
  );
  [
    ["E010", "Rodel Tupas", "Welder (SMAW NC II)"],
    ["E011", "Arnel Gonzaga", "Pipe Fitter"],
    ["E012", "Leo Belleza", "Industrial Electrician"],
    ["E013", "Nestor Sorongon", "Helper"],
    ["E014", "Mario Villanueva", "Duct Fabricator"],
    ["E015", "Ricky Escobido", "CAD Drafter"],
    ["E016", "Jessa Lumawag", "QA/QC Welding Inspector"],
  ].forEach(([id, name, position], i) =>
    s.employees.push({
      id,
      name,
      position,
      dept: "Site Operations",
      basic: 0,
      pay: "FIELD",
      hired: "",
      status: "PROJECT",
      lic: null,
      tin: i === 3 ? "" : `5${10 + i}-${300 + i * 11}-${100 + i * 7}-000`,
      sss: `07-${3300000 + i * 977}-${i + 2}`,
      osh: i !== 4,
    }),
  );
  s.deployments = [
    [
      "DP-0001",
      "E010",
      "BLR",
      "DAILY",
      800,
      "",
      0,
      1450,
      0,
      "2026-09-14",
      "2026-12-12",
      1,
    ],
    [
      "DP-0002",
      "E011",
      "BLR",
      "DAILY",
      750,
      "",
      0,
      1350,
      0,
      "2026-09-14",
      "2026-10-31",
      1,
    ],
    [
      "DP-0003",
      "E012",
      "ELC",
      "DAILY",
      850,
      "",
      0,
      1500,
      150,
      "2026-08-03",
      "2026-10-17",
      1,
    ],
    [
      "DP-0004",
      "E013",
      "CNV",
      "DAILY",
      540,
      "",
      0,
      1050,
      350,
      "2026-10-01",
      "2026-12-19",
      0,
    ],
    [
      "DP-0005",
      "E014",
      "CNV",
      "PIECE",
      130,
      "duct section",
      5,
      230,
      350,
      "2026-10-01",
      "2026-12-19",
      1,
    ],
    [
      "DP-0006",
      "E015",
      "FPR",
      "PIECE",
      1000,
      "drawing sheet",
      0.75,
      1800,
      0,
      "2026-09-01",
      "2026-11-27",
      1,
    ],
    [
      "DP-0007",
      "E016",
      "HSE",
      "DAILY",
      900,
      "",
      0,
      1600,
      200,
      "2026-07-06",
      "2026-09-30",
      1,
    ],
  ].map((r) => ({
    id: r[0],
    emp: r[1],
    project: r[2],
    type: r[3],
    rate: P(r[4]),
    unit: r[5],
    std: r[6],
    bill: P(r[7]),
    perDiem: P(r[8]),
    from: r[9],
    to: r[10],
    contract: !!r[11],
    rest: 0,
    status: "ACTIVE",
  }));
  Object.assign(s.deployments[6], { status: "ENDED", endedOn: "2026-09-30" });
  s.seq.dep = 7;
  s.depBilled = {};
  s.employees
    .filter((e) => e.pay === "FIELD")
    .forEach((e) => (e.hired = s.deployments.find((d) => d.emp === e.id).from));
  const wdays = (from, to, skip = []) => {
    const o = [];
    for (let x = from; x <= to; x = addDays(x, 1))
      if (wd(x) !== 0 && !skip.includes(x)) o.push(x);
    return o;
  };
  const A1 = "2026-10-01",
    A2 = "2026-10-16",
    c1 = wdays(A1, "2026-10-15"),
    c2 = wdays(A2, "2026-10-22");
  s.att = {
    ["DP-0001|" + A1]: { dates: [...c1, "2026-10-11"].sort(), ot: 16, nd: 24 },
    ["DP-0002|" + A1]: { dates: c1, ot: 10, nd: 24 },
    ["DP-0003|" + A1]: {
      dates: wdays(A1, "2026-10-15", ["2026-10-08"]),
      ot: 6,
      nd: 0,
    },
    ["DP-0004|" + A1]: { dates: c1, ot: 0, nd: 0 },
    ["DP-0005|" + A1]: { dates: c1, ot: 0, nd: 0, units: 70 },
    ["DP-0006|" + A1]: { dates: c1, ot: 0, nd: 0, units: 9 },
    ["DP-0001|" + A2]: { dates: [...c2, "2026-10-18"].sort(), ot: 8, nd: 12 },
    ["DP-0002|" + A2]: { dates: c2, ot: 4, nd: 0 },
    ["DP-0003|" + A2]: { dates: c2, ot: 0, nd: 0 },
    ["DP-0004|" + A2]: { dates: c2, ot: 0, nd: 0 },
    ["DP-0005|" + A2]: { dates: c2, ot: 0, nd: 0, units: 22 },
    ["DP-0006|" + A2]: { dates: c2, ot: 0, nd: 0, units: 4 },
  };
  const r1 = mkRun(s, "2026-10-01", "2026-10-15", "2026-10-15", "u5");
  r1.status = "APPROVED";
  r1.ap = "u2";
  postAccrual(s, r1);
  r1.status = "RELEASED";
  r1.rel = "u2";
  postRelease(s, r1);
  mkRun(s, "2026-10-16", "2026-10-31", "2026-10-30", "u5");
  const L = (emp, type, from, to, days, status, reason, by) =>
    s.leaves.push({
      id: "LV-" + ++s.seq.lv,
      emp,
      type,
      from,
      to,
      days,
      status,
      reason,
      by,
    });
  L(
    "E006",
    "SIL",
    "2026-10-27",
    "2026-10-28",
    2,
    "PENDING",
    "Family matter in Antique, after the Cebu site visit",
  );
  L(
    "E008",
    "PAT",
    "2026-11-02",
    "2026-11-10",
    7,
    "PENDING",
    "Birth of child, 30 Oct",
  );
  L("E003", "VL", "2026-11-03", "2026-11-05", 3, "PENDING", "Out of town");
  L(
    "E007",
    "SL",
    "2026-10-12",
    "2026-10-12",
    1,
    "APPROVED",
    "Fever, med cert attached",
    "u6",
  );
  s.audit.push({
    t: new Date().toISOString(),
    u: "system",
    a: "Seed",
    d: "Demo company created from Artemis One templates",
  });
  s.users.forEach((u, i) => {
    u.email =
      u.id === "u8"
        ? "rsantos@santosco.example"
        : u.name.split(/[ ,]/)[0].toLowerCase() +
          "." +
          u.name
            .split(" ")
            .pop()
            .toLowerCase()
            .replace(/[^a-z]/g, "") +
          "@milltech.example";
    u.status = u.status || "ACTIVE";
    u.mfa = !["u7", "u8", "u9"].includes(u.id);
    u.lastSeen =
      u.status === "ACTIVE"
        ? new Date(Date.now() - (i + 1) * 5.3e6).toISOString()
        : null;
  });
  s.settings = {
    mfaRequired: true,
    sessionMin: 30,
    pwMin: 12,
    ipAllow: "",
    jvLimit: P(500000),
    backupAt: new Date(Date.now() - 6 * 36e5).toISOString(),
    dpo: "Grace Tolentino, HR & Admin Manager (sample)",
    npc: "Registration pending (sample)",
  };
  s.signins = [
    ["u2", 1, "Chrome on macOS", 30],
    ["u3", 1, "Edge on Windows", 26],
    [
      null,
      0,
      "Unknown device, Manila",
      20,
      "Wrong password",
      "liza.mercado@milltech.example",
    ],
    [
      null,
      0,
      "Unknown device, Manila",
      19.9,
      "Wrong password",
      "liza.mercado@milltech.example",
    ],
    ["u1", 1, "Safari on iPhone", 8],
    ["u5", 1, "Chrome on Windows", 4],
    ["u4", 1, "Chrome on macOS", 2],
  ].map((r) => ({
    t: new Date(Date.now() - r[3] * 36e5).toISOString(),
    u: r[0],
    ok: !!r[1],
    dev: r[2],
    why: r[4],
    email: r[5],
  }));
  s.company = {
    name: "MILLTECH INDUSTRIAL CONSULTANCY CORP. (sample)",
    style: "Milltech",
    tin: "010-234-567-00000",
    address:
      "Unit 5, Sample Building, Diversion Road, Mandurriao, Iloilo City 5000 (sample)",
    rdo: "Iloilo City (sample)",
    cas: "Computerized invoicing system: BIR acknowledgment pending (sample)",
    dole: { status: "NONE" },
    pcab: { status: "NONE" },
  };
  s.clients = [
    [
      "C1",
      "Western Visayas Power Co. (sample)",
      "201-555-101-00000",
      "Brgy. Lapuz Norte, Lapuz, Iloilo City 5000 (sample)",
    ],
    [
      "C2",
      "Visayas Cement Corp. (sample)",
      "202-555-102-00000",
      "Sitio Malubog, Brgy. Tina-an, Naga City, Cebu 6037 (sample)",
    ],
    [
      "C3",
      "Ilonggo Food Processing Inc. (sample)",
      "203-555-103-00000",
      "Brgy. Ungka II, Pavia, Iloilo (sample)",
    ],
    [
      "C4",
      "Capiz Sugar Milling Co. (sample)",
      "204-555-104-00000",
      "Brgy. Ilaya, Pontevedra, Capiz (sample)",
    ],
    [
      "C5",
      "Guimaras Logistics Park Inc. (sample)",
      "205-555-105-00000",
      "Brgy. Alegria, Buenavista, Guimaras (sample)",
    ],
  ].map((r) => ({ id: r[0], name: r[1], tin: r[2], address: r[3], vat: true }));
  s.projects.forEach((p, i) => (p.cid = "C" + (i + 1)));
  s.seq.inv = 0;
  const iv = [];
  s.projects.forEach((p) => {
    const h = Math.round(p.billed / 2);
    iv.push(
      { p, date: "2026-06-15", net: h },
      { p, date: "2026-09-15", net: p.billed - h },
    );
  });
  s.invoices = iv
    .sort(
      (a, b) =>
        a.date.localeCompare(b.date) || a.p.code.localeCompare(b.p.code),
    )
    .map(({ p, date, net }) => {
      const t = invTotals(net, 7.5),
        cl = s.clients.find((c) => c.id === p.cid),
        june = date < "2026-07-01",
        paid = june || p.code !== "BLR";
      return {
        no: "SI-" + String(++s.seq.inv).padStart(6, "0"),
        date,
        client: cl.id,
        project: p.code,
        desc: `Progress billing, ${p.name}`,
        ...t,
        retPct: 7.5,
        status: paid ? "PAID" : "UNPAID",
        paidOn: paid ? (june ? "2026-07-10" : "2026-10-08") : undefined,
        cwt: paid ? Math.round(net * 0.925 * 0.15) : 0,
        f2307: paid
          ? june && ["ELC", "HSE"].includes(p.code)
            ? "RECEIVED"
            : "PENDING"
          : undefined,
        by: "u3",
        je: "JV-0002 (Jan–Sep summary)",
        seller: { ...s.company },
        buyer: { name: cl.name, tin: cl.tin, address: cl.address },
      };
    });
  s.runs
    .filter((r) => r.status === "DRAFT")
    .forEach((r) => (r.lines = runLines(s, r.from, r.to)));
  return s;
}

function ensureSites(s) {
  migrateWorkLogs(s);
  s.sites = s.sites || [];
  s.projects.forEach((p) => {
    let site =
      s.sites.find((x) => x.id === p.siteId) ||
      s.sites.find((x) => x.name === p.site);
    if (!site) {
      site = {
        id: p.code,
        code:
          p.locationCode ||
          `${p.code}-${String(s.sites.length + 1).padStart(3, "0")}`,
        name: p.site,
        region: p.region,
      };
      s.sites.push(site);
    }
    p.siteId = site.id;
  });
  return s;
}

export { seed, ensureSites };
